import type { UserAvatarSize } from "./UserAvatar";

/** Fine detail (the "5K" plate) only reads from ~64px; below that use the simplified artwork. */
const FULL_FRAME_SIZES = new Set<UserAvatarSize>(["hero", "lg", "fill"]);
const SMALL_FRAME_SIZES = new Set<UserAvatarSize>(["chip", "md", "xs", "sm", "compact"]);

/** Frame artwork for an avatar size, or null where a frame would just be noise (≤ 22px). */
export function resolveAvatarFrameSrc(
  size: UserAvatarSize,
  frameUrl?: string | null,
  frameSmallUrl?: string | null,
): string | null {
  const full = String(frameUrl ?? "").trim();
  if (!full) return null;
  if (FULL_FRAME_SIZES.has(size)) return full;
  if (SMALL_FRAME_SIZES.has(size)) return String(frameSmallUrl ?? "").trim() || full;
  return null;
}

/** Spread onto `UserAvatar` from any API row that carries `avatar_frame_url` / `avatar_frame_small_url`. */
export function avatarFrameProps(row: { avatar_frame_url?: string | null; avatar_frame_small_url?: string | null } | null | undefined) {
  return {
    avatarFrameUrl: row?.avatar_frame_url ?? null,
    avatarFrameSmallUrl: row?.avatar_frame_small_url ?? null,
  };
}
